import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';

import Card from 'components/Account/Common/Card/Card';
import PersonalDetailsInformations from './PersonalDetailsInformations/PersonalDetailsInformations';
import { MOBILE_AND_TABLET_PORTRAIT } from 'settings/mediaQuery';

import styles from './EditInformation.module.scss';

export default function EditInformation(): JSX.Element {
  const { t } = useTranslation(['personalDetailsPage']);
  const isMobileAndPortraitTablet = useMediaQuery({
    query: MOBILE_AND_TABLET_PORTRAIT,
  });

  return (
    <Card classes={{ container: styles.editinfoBlock }}>
      <div className={styles.editinfosTitle}>
        <label>
          {!isMobileAndPortraitTablet && (
            <FontAwesomeIcon icon={faChevronRight} />
          )}
          {t('LABEL_EDIT_INFOS')}
        </label>
      </div>
      <PersonalDetailsInformations />
    </Card>
  );
}
